export default function SkillsHeader() {
  return (
    <div className="skills-header">
      <span className="subheading">Skills</span>
      <h2 className="heading-secondary">Skills & Expertise</h2>
      <p className="skills-description">
        A comprehensive overview of my technical skills, expertise levels, and
        areas of specialization across different domains of software development
      </p>
    </div>
  );
}
